import { useEffect } from 'react';
import { useGate, useUnit } from 'effector-react';

import { getSurveyQuestionsFx, postSurveyAnswersFx } from 'shared/api';
import { useLocalStorage } from 'shared/hooks/useLocalStorage';
import { theme } from 'shared/styles/theme';
import { ScrollToError } from 'shared/ui/FormComponents/ScrollToError';
import { Spinner } from 'shared/ui/Spinner';
import { YellowButton } from 'shared/ui/Styled';
import { Flex } from 'shared/ui/StyledComponents';
import { Typography } from 'shared/ui/Typography';

import { FieldArray, Form, FormikErrors } from 'formik';
import { getComponentByQuestionType } from '../lib/getComponentByQuestionType';
import { FormValues } from '../model';
import { baseLocalStorageKey, factory } from '../model/model';

type Props = {
  values: FormValues;
  errors?: FormikErrors<FormValues>;
};

export const FormView = ({ values, errors }: Props) => {
  const model = factory.useModel();
  useGate(model.SurveyGate);

  const questions = useUnit(model.$questions);

  const [_, setValue] = useLocalStorage(baseLocalStorageKey);

  useEffect(() => {
    setValue(values);
  }, [values]);

  const isPostAnswersLoading = useUnit(postSurveyAnswersFx.pending);

  const isGetQuestionsLoading = useUnit(getSurveyQuestionsFx.pending);
  if (isGetQuestionsLoading) return <Spinner />;

  return (
    <Form>
      <ScrollToError />
      <FieldArray
        name='answers'
        render={() => (
          <Flex flexDirection='column' gap={30} padding={20} width='100%'>
            {questions?.questions.map((question, index) => (
              <div key={index} className='question'>
                {getComponentByQuestionType({
                  item: question,
                  index,
                  key: question.id,
                })}
              </div>
            ))}
            <Flex gap={10} alignItems='center'>
              <YellowButton type='submit' disabled={isPostAnswersLoading}>
                Отправить
              </YellowButton>
              {errors && errors?.answers && <Typography color={theme.colors.red}>Ответ на первый вопрос обязателен</Typography>}
            </Flex>
          </Flex>
        )}
      />
    </Form>
  );
};
